// src/api/routes.js
const API_ROUTES = {
    segments: '/segments',
    login: '/auth/login', 
    products: '/products',
    dashboard: '/dashboard',
    messages: '/messages',
    orders: '/orders',
    orderhistory: '/orderhistory',
    sellerfilter: '/sellerFilter/',
    unregistered: '/unregistered',
    /** REST API path. Seller portal list/edit uses hash `#/blogs` (labels say “News”). */
    blogs: '/blogs',
    bids:'/bids',
    inquiries:'/inquiries'
};

export default API_ROUTES;
